module.exports = __webpack_public_path__ + "static/media/iconfinder_social_media_social_media_logo_git_2993773.8e4cd62e.svg";